import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Potomac Press &middot; Regional News & Culture</p>
        <h1>Potomac Region News and Culture</h1>
        <p className="lede">
          Coverage of news, arts, and community life across the Potomac region, from Washington, DC's major institutions to the towns along the river.
        </p>
        <div className="cta-row">
          <a href="#latest-news" target="_self">
            Latest News
          </a>
          <a href="#about" target="_self" className="secondary">
            About
          </a>
        </div>
      </header>

      <section className="cards" id="latest-news">
        <article>
          <h2>Hirshhorn opens major Adam Pendleton exhibition</h2>
          <p>"Adam Pendleton: Love, Queen" explores Blackness, abstraction, and language through paintings, video, and installation at the Hirshhorn Museum, on view through December 31, 2026.</p>
        </article>
        <article>
          <h2>Renwick Gallery pairs maize-inspired installation with craft survey</h2>
          <p>"Capilla de Maiz & State Fairs" and "State Fairs: Growing American Craft" run concurrently at the Renwick Gallery through September 7, 2026.</p>
        </article>
        <article>
          <h2>Capital Art Book Fair returns to Eastern Market</h2>
          <p>The 2026 Capital Art Book Fair takes over Eastern Market's North Hall March 28-29, free and open to the public.</p>
        </article>
      </section>

      <section className="cards" id="about">
        <article>
          <h2>Regional Coverage</h2>
          <p>
            News, arts, and culture from across the Potomac region -- Washington, DC and the surrounding communities along the river.
          </p>
        </article>
        <article>
          <h2>Arts & Exhibitions</h2>
          <p>
            Museum shows, gallery openings, and literary events worth knowing about, from major institutions to neighborhood spaces.
          </p>
        </article>
        <article>
          <h2>Community & Events</h2>
          <p>
            Festivals, guided hikes along the Potomac, and the seasonal happenings that mark life in the region.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;